import { useLocation } from 'react-router-dom';
import styles from './aboutus.module.css'
import {
  BreadCrumb,
  Banner,
} from "../../../components/shared/index";
import Store from './Store';
import Stats from './Stats';
import Teams from './Teams';

const About = () => {
  const { pathname } = useLocation();
  const parts = pathname.split("/");
  const newPath = parts[parts.length - 2];
  return (
      <section className={styles.about__wrapper}>
      <BreadcrumbBanner
        newPath={newPath}
        heading="We're dedicated to providing safe, authentic healthcare products with convenience and care"
        imageUrl="/assets/img/backgrounds/aboutbanner.png"
      />
      <Store/>
      <Stats/>
      <Teams/>
    </section>
  )
}
const BreadcrumbBanner = ({ newPath, heading, imageUrl }) => (
  <>
    <BreadCrumb customPaths={[{ label: "About Us", path: newPath }]} />
    <Banner heading={heading} imageUrl={imageUrl} />
  </>
);

export default About
